<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center mb-4">
          <v-btn @click="$router.push('/lists')" 
                 icon="mdi-arrow-left" 
                 variant="text" 
                 class="me-3">
          </v-btn>
          <h1 class="text-h4">
            <v-icon class="me-2">mdi-shield-account</v-icon>
            Admin Panel
          </h1>
        </div>
        
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon class="me-2">mdi-account-group</v-icon>
            Registered Users
            <v-spacer></v-spacer>
            <v-btn @click="loadUsers" :loading="loading" color="primary" variant="text">
              <v-icon>mdi-refresh</v-icon>
              Refresh
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-alert v-if="error" type="error" class="mb-4">
              {{ error }}
            </v-alert>
            
            <v-data-table
              v-if="!loading && users.length > 0"
              :headers="headers"
              :items="users"
              :loading="loading"
              class="elevation-1"
              item-value="id"
            >
              <template v-slot:item.role="{ item }">
                <v-chip
                  :color="item.role === 'ADMIN' ? 'warning' : 'primary'"
                  variant="tonal"
                  size="small"
                >
                  <v-icon start>
                    {{ item.role === 'ADMIN' ? 'mdi-shield-account' : 'mdi-account' }}
                  </v-icon>
                  {{ item.role }}
                </v-chip>
              </template>
              
              <template v-slot:item.created_at="{ item }">
                {{ formatDate(item.created_at) }}
              </template>
              
              <template v-slot:item.list_count="{ item }">
                <v-chip color="info" variant="tonal" size="small">
                  {{ item.list_count }}
                </v-chip>
              </template>
            </v-data-table>
            
            <div v-else-if="!loading && users.length === 0" class="text-center py-8">
              <v-icon size="64" color="grey">mdi-account-off</v-icon>
              <p class="text-h6 mt-4">No users found</p>
            </div>
            
            <div v-if="loading" class="text-center py-8">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
              <p class="mt-4">Loading users...</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { useAuthStore } from '../stores/auth'

export default {
  name: 'Admin',
  setup() {
    const authStore = useAuthStore()
    return { authStore }
  },
  
  data() {
    return {
      users: [],
      loading: false,
      error: null,
      headers: [
        { title: 'Username', key: 'username', align: 'start' },
        { title: 'Role', key: 'role', align: 'center' },
        { title: 'Registration Date', key: 'created_at', align: 'center' },
        { title: 'Number of Lists', key: 'list_count', align: 'center' }
      ]
    }
  },
  
  async mounted() {
    // Check if user is admin
    if (this.authStore.user?.role !== 'ADMIN') {
      this.$router.push('/lists')
      return
    }
    
    await this.loadUsers()
  },
  
  methods: {
    async loadUsers() {
      this.loading = true
      this.error = null
      
      try {
        const response = await axios.get('/api/admin/users')
        this.users = response.data
      } catch (error) {
        this.error = error.response?.data?.detail || 'Failed to load users'
        console.error('Error loading users:', error)
      } finally {
        this.loading = false
      }
    },
    
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { 
        hour: '2-digit', 
        minute: '2-digit' 
      })
    }
  }
}
</script>

<style scoped>
.v-data-table {
  background-color: transparent;
}
</style>